module.exports = __webpack_public_path__ + "cf40c514ea4b3969e61e8a81dbf6b788.jpg";